import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-plan-terms-modal',
  templateUrl: './plan-terms-modal.component.html',
  styleUrls: ['./plan-terms-modal.component.scss']
})
export class PlanTermsModalComponent implements OnInit {

  constructor(private activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

   closeDialog() {
    this.activeModal.close();
  }

}
